import React, { useContext, useEffect, useState } from "react";
import "~/assets/sass/pages/round/roundReg/dynamicForm.scss";
import { PlusIcon } from "~/assets/svg/MathIcon";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import { AppContext } from "../RoundRegContext";
import InquiryCardGroup from "./content/InquiryCardGroup";
import { CategoryIcon } from "~/assets/svg/InterfaceIcon";

import CompanyInfoModal from "./modals/CompanyInfoModal";
import PreviewInquiryModal from "./modals/PreviewInquiryModal";
import { useTranslation } from "react-i18next";
import useAlert from "~/common/hooks/useAlert";

const Inquiry = ({ setStep }) => {
	const { t } = useTranslation();
	const [companyInfoModal, setCompanyInfoModal] = useState();
	const [inquiryPreModal, setInquiryPreModal] = useState();
	const { addCategory, addInquiry, list, setList, inquiryForm } = useContext(AppContext);
	const [showWarningAlert, Warning] = useAlert();
	const [showDuplicatedAlert, DuplicatedAlert] = useAlert();
	const [duplicatedTitle, setDuplicatedTitle] = useState("");

	// 버튼 클릭 체크 flag
	const [isUpd, setIsUpd] = useState(false);

	const validateBeforeEdit = () => {
		if (list.some((item) => !item.title)) showWarningAlert();
		else if (
			list.some((item) => {
				const isDuplicate =
					(item.type === "SELECT" || item.type === "MULTISELECT") &&
					new Set(item.selectOption).size < item.selectOption.length;
				if (isDuplicate) setDuplicatedTitle(item.title);
				return isDuplicate;
			})
		) {
			showDuplicatedAlert();
		} else setStep("edit");
	};

	useEffect(() => {
		inquiryForm.setValue("inquiry", list[0].title);
		inquiryForm.setValue("inquiryDesc", list[0].content);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [list]);

	useEffect(() => {
		if(list.length <= 1) {
			setCompanyInfoModal(true);
		}
		// return () => {
		// 	setList([{ type: "TITLE", title: "", content: "", order: 0, selectOption: [], required: false }])
		// }
	}, [])


	return (
		<>
			{/*Inquiry*/}
			<div className="dynamic-form-wrap">
				<div className="dynamic-form-head">
					<h3>{t("pages.round.RoundReg.container.Inquiry.h3")}</h3>
					<button
						className="dashed-btn plus-btn"
						onClick={() => {
							setCompanyInfoModal(true);
							setIsUpd(true);
						}}
					>
						<PlusIcon />
						{t("pages.round.RoundReg.container.Inquiry.button")}
					</button>
				</div>
				<div className="c__card dynamic-form-title">
					<Form useForm={inquiryForm}>
						<Input
							name="inquiry"
							placeholder={t("pages.round.RoundReg.container.Inquiry.placeholder")}
							className="export-label"
							required
						/>
						<Input
							name="inquiryDesc"
							placeholder={t("pages.round.RoundReg.container.Inquiry.inquiryDesc")}
						/>
					</Form>
				</div>
				<InquiryCardGroup list={list} />
				{/*카드생성*/}
				<ul className="inquiry-card-group">
					<li className="c__card card-generator">
						<button
							type="button"
							className="dynamic-btn-category"
							onClick={() => addCategory()}
						>
							<CategoryIcon />
						</button>
						<button
							type="button"
							className="dynamic-btn-plus"
							onClick={() => addInquiry()}
						>
							<PlusIcon />
						</button>
					</li>
				</ul>
			</div>
			<div className="floating-btn-group">
				<button
					type="button"
					className="btn__outline btn-preview"
					color="primary"
					onClick={() => setInquiryPreModal(true)}
				>
					{t("pages.round.RoundReg.container.Inquiry.btn-preview")}
				</button>
				<button
					type="button"
					className="btn__solid btn-back"
					color="primary"
					onClick={inquiryForm.handleSubmit(validateBeforeEdit)}
				>
					{t("pages.round.RoundReg.container.Inquiry.btn-back")}
				</button>
			</div>

			{/*기본 기업 정보 모달*/}
			<CompanyInfoModal {...{ companyInfoModal, setCompanyInfoModal, setStep, isUpd }} />

			{/*질의항목 미리보기 모달*/}
			<PreviewInquiryModal {...{ inquiryPreModal, setInquiryPreModal }} />

			<Warning
				type="info"
				message={t("pages.applyFormMange.ApplyForm.WarningMassage")}
				subMessage={t("pages.applyFormMange.ApplyForm.setWarningMsg")}
				confirm={t("common.commonWord.button.check")}
			/>

			<DuplicatedAlert
				type="info"
				message={"중복 사항 확인"}
				subMessage={`'${duplicatedTitle}'의 동일한 옵션이 입력됐습니다. \n옵션 수정 부탁드립니다.`}
				confirm={t("common.commonWord.button.check")}
			/>
		</>
	);
};

export default Inquiry;
